// utils/pdfGenerator.js
const IVA_RATE = 0.21;

export const generatePDF = (calculatedData, setGeneratingPDF) => {

    const fechaFormateada = new Date().toLocaleDateString('es-AR', {
        day: '2-digit',
        month: '2-digit', 
        year: 'numeric'
    }).replace(/\//g, '-');

    const nombreEmpresaLimpio = (calculatedData.nombreEmpresa || 'Cliente')
        .replace(/\s+/g, '_')
        .replace(/[^\w\-]/g, '')
        .toLowerCase();

    setGeneratingPDF(true);

    import('jspdf').then(({ jsPDF }) => {
        const doc = new jsPDF();

        doc.setFont('helvetica');
        
        // Logo
        const logoPath = '/logo.jpg';
        const logoWidth = 50;
        const logoHeight = 25;
        const logoX = 20;
        try {
            doc.addImage(logoPath, 'JPEG', logoX, 10, logoWidth, logoHeight);
        } catch (error) {
            console.warn('No se pudo cargar el logo:', error);
        }

        // Fecha
        doc.setFontSize(9);
        doc.setTextColor(102, 102, 102);
        const fechaImpresion = new Date().toLocaleDateString('es-AR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        doc.text(`Fecha de impresión: ${fechaImpresion}`, 105, 15);

        let yPos = 45;

        // Comunicado
        if (calculatedData.comunicado) {
            doc.setFontSize(12);
            doc.setTextColor(51, 51, 51);
            const comunicadoLines = doc.splitTextToSize(calculatedData.comunicado, 170);
            comunicadoLines.forEach(line => {
                if (yPos > 270) {
                    doc.addPage();
                    yPos = 20;
                }
                doc.text(line, 20, yPos);
                yPos += 6;
            });
            yPos += 5;
        } else {
            doc.setFont('helvetica', 'bold');
            doc.text('ESTIMADO CLIENTE:', 20, yPos);
            yPos += 10;
            doc.setFont('helvetica', 'normal');
            const textoIntroduccion = `Nos dirigimos a usted para informarle sobre los ajustes tarifarios que se implementarán de manera progresiva en nuestros servicios, debido a las fluctuaciones económicas actuales y el incremento en los costos operativos.`;
            const lineasIntro = doc.splitTextToSize(textoIntroduccion, 170);
            doc.text(lineasIntro, 20, yPos);
            yPos += lineasIntro.length * 6 + 10;
        }

        doc.setFont('helvetica', 'bold');
        doc.setTextColor(102, 126, 234);
        doc.text('CRONOGRAMA DE AJUSTES:', 20, yPos);
        yPos += 5;

        const mesesData = [];
        const NOMBRES_MESES = {
            ene: 'Enero', feb: 'Febrero', mar: 'Marzo', abr: 'Abril',
            may: 'Mayo', jun: 'Junio', jul: 'Julio', ago: 'Agosto',
            sep: 'Septiembre', oct: 'Octubre', nov: 'Noviembre', dic: 'Diciembre'
        };

        if (calculatedData.mesesOrdenados && Array.isArray(calculatedData.mesesOrdenados)) {
            calculatedData.mesesOrdenados.forEach(mes => {
                const mesKey = mes.key;
                const porcentajeKey = `porcentaje${mesKey.charAt(0).toUpperCase() + mesKey.slice(1)}`;
                const montoKey = `monto${mesKey.charAt(0).toUpperCase() + mesKey.slice(1)}`;
                const bonoKey = `bono${mesKey.charAt(0).toUpperCase() + mesKey.slice(1)}`;
                const porcentajeIndividual = calculatedData[porcentajeKey] || 0;
                const montoSinIva = calculatedData[montoKey] || calculatedData.montoBase;
                const bonoSinIva = calculatedData[bonoKey] || 0;
                
                if (porcentajeIndividual > 0 || bonoSinIva > 0) {
                    // Calcular totales ya sumados
                    const totalSinIva = montoSinIva + bonoSinIva;
                    const totalConIva = totalSinIva * (1 + IVA_RATE);
                    
                    mesesData.push({
                        nombre: NOMBRES_MESES[mesKey] || mes.label,
                        totalSinIva: totalSinIva,
                        totalConIva: totalConIva,
                        tieneBono: bonoSinIva > 0
                    });
                }
            });
        }

        const showSinIva = calculatedData.showSinIva !== false;
        doc.setFont('helvetica', 'bold');
        doc.setFillColor(102, 126, 234);
        doc.setTextColor(255, 255, 255);
        doc.rect(20, yPos, 170, 10, 'F');
        doc.text('MES', 25, yPos + 7);
        if (showSinIva) {
            doc.text('SIN IVA', 70, yPos + 7);

        } else {
            doc.text('SIN IVA', 70, yPos + 7);
            doc.text('TOTAL (CON IVA)', 110, yPos + 7);
        }
        yPos += 10;

        doc.setFont('helvetica', 'normal');
        doc.setTextColor(51, 51, 51);
        mesesData.forEach((mes, index) => {
            if (yPos > 270) {
                doc.addPage();
                yPos = 20;
                doc.setFont('helvetica', 'bold');
                doc.setFillColor(102, 126, 234);
                doc.setTextColor(255, 255, 255);
                doc.rect(20, yPos, 170, 10, 'F');
                doc.text('MES', 25, yPos + 7);
                if (showSinIva) {
                    doc.text('SIN IVA', 70, yPos + 7);
                } else {
                    doc.text('SIN IVA', 70, yPos + 7);
                    doc.text('TOTAL (CON IVA)', 110, yPos + 7);
                }
                yPos += 10;
                doc.setFont('helvetica', 'normal');
                doc.setTextColor(51, 51, 51);
            }
            const bgColor = index % 2 === 0 ? [248, 249, 250] : [255, 255, 255];
            doc.setFillColor(...bgColor);
            doc.rect(20, yPos, 170, 8, 'F');
            
            let nombreMes = mes.nombre;
            if (mes.tieneBono) {
                nombreMes += ` (+Bono)`;
            }
            
            doc.text(nombreMes, 25, yPos + 5);
            
            if (showSinIva) {
                // Mostrar totales ya sumados directamente
                doc.text(mes.totalSinIva.toLocaleString('es-AR'), 70, yPos + 5);
            } else {
                // Mostrar solo el total con IVA
                doc.text(mes.totalSinIva.toLocaleString('es-AR'), 70, yPos + 5);
                doc.text(mes.totalConIva.toLocaleString('es-AR'), 110, yPos + 5);
            }
            yPos += 8;
        });

        yPos += 8;

        doc.setFont('helvetica', 'normal');
        doc.setTextColor(51, 51, 51);
        const cierre = `Quedo a disposición ante cualquier consulta o comentario que Ud. considere oportuno.`;
        const cierreLines = doc.splitTextToSize(cierre, 170);
        doc.text(cierreLines, 20, yPos);
        yPos += cierreLines.length * 6 + 15;

        doc.text('Sin otro particular, saluda cordialmente.', 20, yPos);
        yPos += 10;

        // Nombre y cargo centrados
        doc.setFont('helvetica', 'normal');
        doc.text('Gte. General, Estilo Limpio', 105, yPos, { align: 'center' });

        // Footer con páginas
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(128, 128, 128);
            doc.text(`Página ${i} de ${totalPages}`, 105, 290, { align: 'center' });
            doc.setDrawColor(200, 200, 200);
            doc.setLineWidth(0.5);
            doc.line(20, 285, 190, 285);
        }

        const nombreArchivo = `${nombreEmpresaLimpio}_${fechaFormateada}.pdf`;
        doc.save(nombreArchivo);
        setGeneratingPDF(false);

    }).catch(error => {
        console.error('Error al cargar jsPDF:', error);
        alert('Error al generar el PDF. Por favor, intente nuevamente.');
        setGeneratingPDF(false);
    });
};